<template>
  <div class="register">
    <el-form
      class="login-form"
      :model="registerForm"
      :rules="registerRules"
      ref="registerForm"
      label-width="200px"
      label-position="right"
    >
      <div class="title">
        <span style="font-size:24px;font-weight:bold">注册企业账号</span>
        <span
          @click="goLogin"
          style="font-size:14px;cursor: pointer;"
        >已有账号,直接登录</span>
      </div>
      <el-row>
        <el-form-item
          label="企业名称: "
          prop="qymc"
        >
          <el-input
            name="qymc"
            v-model="registerForm.qymc"
            autocomplete="on"
            placeholder="请输入企业名称"
          />
        </el-form-item>
      </el-row>

      <el-row>
        <el-form-item
          label="统一社会信用代码: "
          prop="dm"
        >
          <el-input
            name="dm"
            v-model="registerForm.dm"
            autocomplete="on"
            placeholder="统一社会信用代码"
          />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="法定代表人: "
          prop="fddbr"
        >
          <el-input
            name="fddbr"
            v-model="registerForm.fddbr"
            autocomplete="on"
            placeholder="请输入法定代表人"
          />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="联系人: "
          prop="username"
        >
          <el-input
            name="username"
            v-model="registerForm.username"
            autocomplete="on"
            placeholder="请输入联系人"
          />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="法定代表人身份证号: "
          prop="idcard"
        >
          <el-input
            name="idcard"
            v-model="registerForm.idcard"
            autocomplete="on"
            placeholder="请输入法定代表人身份证号"
          />
        </el-form-item>

      </el-row>
      <el-row>
        <el-form-item
          label="手机号: "
          prop="phone"
        >
          <el-input
            name="phone"
            v-model="registerForm.phone"
            autocomplete="on"
            placeholder="请输入手机号"
          >

          </el-input>
        </el-form-item>
        <el-row>
          <el-row>
            <el-form-item
              prop="validCode"
              label="图形验证码: "
            >
              <el-input
                v-model="registerForm.validCode"
                name="validCode"
                autocomplete="off"
                placeholder="验证码"
              />
              <img
                class="valite-img"
                :src="src"
                alt="验证码"
                @click="changeImg"
              />
            </el-form-item>
          </el-row>
        </el-row>
        <el-form-item
          label="短信验证码: "
          prop="code"
        >
          <el-input
            name="code"
            v-model="registerForm.code"
            autocomplete="on"
            placeholder="请输入验证码"
          ><template slot="append">
              <el-button @click="getCode()">{{
                    title
                    }}</el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-row>

      <el-row>

        <el-form-item
          prop="password"
          label="密码:"
        >
          <el-input
            v-model="registerForm.password"
            name="password"
            type="password"
            autocomplete="off"
            placeholder="密码"
            prefix-icon="el-icon-lock"
          />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          prop="passwordConfirm"
          label="确认密码:"
        >
          <el-input
            v-model="registerForm.passwordConfirm"
            name="password"
            type="password"
            autocomplete="off"
            placeholder="密码"
            prefix-icon="el-icon-lock"
            @keyup.enter.native="login"
          />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="营业执照" prop="yyzz">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="uploadedFiles">
            <img v-if="registerForm.yyzz" :src="baseUrl+registerForm.yyzz" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-row>

      <div
        class="button-container"
        style="margin:20px 0 10px 0 ;"
      >
        <el-checkbox
          class="protocol"
          v-model="checked1"
        >我已仔细阅读
          <a
            href="javascript:void(0);"
            style="color: #409eff"
            @click="checkProtocol('agreement1')"
          >《注册承诺函》</a></el-checkbox>
      </div>

      <div class="button-container">
        <el-checkbox
          class="protocol"
          v-model="checked2"
        >我已仔细阅读
          <a
            href="javascript:void(0);"
            style="color: #409eff"
            @click="checkProtocol('agreement2')"
          >《信用承诺书》</a></el-checkbox>
      </div>

      <div
        class="button-container"
        style="margin:10px 0 40px 0;"
      >
        <el-checkbox
          class="protocol"
          v-model="checked3"
        >我已仔细阅读
          <a
            href="javascript:void(0);"
            style="color: #409eff"
            @click="checkProtocol('agreement3')"
          > 《授权协议》</a></el-checkbox>
      </div>

      <div class="button-container">
        <el-button
          type="primary"
          style="width: 400px"
          :loading="loading"
          @click="register"
        >注册</el-button>
      </div>
    </el-form>
    <!-- 勾选协议 -->
    <paper-dialog
      v-if="paperDialogData.visible"
      :show-dialog="paperDialogData.visible"
      :content-type="paperDialogData.type"
      :dialog-title="paperDialogData.title"
      @closeDialog="closePaperDialog"
    />
  </div>
</template>
<script>
const base = process.env.VUE_APP_BASE_API || ''
import { register, sendSmsVerCode, checkVerCode, uploadFiles,uploadFilesNoLogin } from '@/api';
import paperDialog from './paperDialog';
import { validateForm, validatePwd, } from '@/utils';
import { rsaEncrypt } from "@/utils/jsencrypt";
export default {
  name: 'register',
  components: {
    paperDialog,
  },
  data () {
    var validateConfirmPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.registerForm.password) {
        callback(new Error("确认密码和新密码不一致。"));
      } else {
        callback();
      }
    };
    return {
      baseUrl: process.env.VUE_APP_IMG_API,
      loading: false,
      protocolDiaView: false,
      checked1: false,
      checked2: false,
      checked3: false,
      second: '', //倒计时
      disabled: false, //是否禁用按钮
      timer: null, //计时器
      src:
        process.env.VUE_APP_BASE_API +
        "/credit/accountLogin/0000/validCode?uid=" +
        Math.random(),
      registerForm: {
        qymc: '',
        dm: '',
        fddbr: '',
        username: '',
        validCode: '',
        phone: '',
        idcard: '',
        code: '',
        password: '',
        passwordConfirm: '',
        yyzz:'',
        fileList:[]
      },
      registerRules: {
        qymc: [
          {
            required: true,
            message: '请输入企业名称',
            trigger: 'blur'
          }
        ],
        dm: [
          {
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'blur'
          }
        ],
        username: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur'
          }
        ],
        fddbr: [
          {
            required: true,
            message: '请输入法定代表人',
            trigger: 'blur'
          }
        ],
        idcard: [
          {
            required: true,
            message: '请输入法定代表人身份证号',
            trigger: 'blur'
          },
          {
            pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '请正确输入身份证号',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            pattern: /^1[0-9]{10}$/,
            message: '请正确输入11位手机号码',
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: '请输入短信验证码',
            trigger: 'blur'
          },
        ],
        validCode: [
          {
            required: true,
            message: '请输入图形验证码',
            trigger: 'change'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          { validator: validatePwd },
        ],
        passwordConfirm: [
          {
            required: true,
            message: '请确认密码',
            trigger: 'blur'
          },
          {
            validator: validateConfirmPwd,
            trigger: ["blur", "change"],
          },
        ],
        yyzz: [
          {
            required: true,
            message: '请上传营业执照',
            trigger: 'blur'
          },
          {
            trigger: ["blur", "change"],
          },
        ]
      },
      cn: {},
      fileList: [],
      titleType: {
        agreement1: {
          type: 4,
          name: "注册承诺函"
        },
        agreement2: {
          type: 5,
          name: "信用承诺书"
        },
        agreement3: {
          type: 6,
          name: "授权协议"
        },
      },
      paperDialogData: {
        visible: false,
        type: "",
        title: "",
      },
    };
  },
  computed: {
    title () {
      return this.disabled ? `重新获取 ( ${this.second} ) s` : '获取验证码';
    },
  },
  methods: {
    goLogin () {
      debugger
      this.$router.push({
        name: 'login',
        query: {
          type: 1
        }
      })
    },
    changeImg () {
      this.src =
        process.env.VUE_APP_BASE_API +
        "/credit/accountLogin/0000/validCode?uid=" +
        Math.random();
    },
    register () {
      if (!validateForm(this.$refs['registerForm'])) {
        return;
      }
      if (!this.checked1 || !this.checked2 || !this.checked3) {
        this.$message({ type: "warning", message: "您有文件还未勾选" });
        return;
      }
      this.loading = true;
      let params = {
        qymc: this.registerForm.qymc,
        dm: this.registerForm.dm,
        fddbr: this.registerForm.fddbr,
        username: this.registerForm.username,
        phone: this.registerForm.phone,
        idcard: this.registerForm.idcard,
        code: this.registerForm.code,
        password: rsaEncrypt(this.registerForm.password),
        passwordConfirm: rsaEncrypt(this.registerForm.passwordConfirm),
        fileList:[this.registerForm.yyzz]
      };
      register(params).then(res => {
        if (res.code == 1000) {
          this.loading = false;
          this.$baseMessage( '注册成功', 'success')
          this.goLogin();
        } else {
          this.loading = false;
          this.$message({ type: 'error', message: res.data.message });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    checkProtocol (name) {
      this.paperDialogData.title = this.titleType[name].name;
      this.paperDialogData.type = this.titleType[name].type;
      this.paperDialogData.visible = true;
    },
    closePaperDialog(){
      this.paperDialogData.visible = false;
    },
    confirmProtocol () {
      this.protocolDiaView = false;
    },
    //获取短信验证码
    getCode () {
      if (!this.registerForm.phone) {
        this.$baseMessage("请先输入手机号", "error");
        return;
      }
      if (!this.registerForm.validCode) {
        this.$baseMessage("请输入图形验证码", "error");
        return;
      }
      console.log("uid:", this.uid)
      checkVerCode({
        uid: this.src.split("=")[1],
        code: this.registerForm.validCode,
      }).then((res) => {
        if (res.code != 1000) {
          return
        }
      });
      let that = this;
      let s = 60  //倒计时间
      if (!that.timer) {
        that.second = s
        that.disabled = true
        that.timer = setInterval(() => {
          if (that.second > 0 && this.second <= s) {
            that.second--
          } else {
            that.disabled = false
            clearInterval(that.timer);
            this.timer = null
          }
        }, 1000)
      }
      // 调用后端发送短信验证码
      sendSmsVerCode({ phone: this.registerForm.phone }).then(res => {
        console.log(33333);
        console.log(res)
        if (res.code != 1000) {
          that.$message({ type: "error", message: res.message });
        }
      });
    },


    //上传
    uploadedFiles (file) {
      let formData = new FormData();
      formData.append('file', file)  
      uploadFilesNoLogin(formData).then(( res )=>{
        if(res.data){
          this.registerForm.yyzz = res.data.url;
        }
      })
    },

    handleAvatarSuccess(res, file) {
      // this.form.image = URL.createObjectURL(file.raw);
    },

  },
  mounted () {
    this.changeImg();
  },
  created () {
  },
};

</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.register {
  padding: 10px 200px 30px 200px;
  box-sizing: border-box;
  background-color: #fff;
  .login-form {
    padding: 0 20%;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 40px 0;
    }

    .valite-img {
      position: absolute;
      right: 3px;
      top: 1px;
      height: 38px;
      cursor: pointer;
    }
  }
  // .title {
  //   font-size: 20px;
  //   letter-spacing: 2px;
  //   font-weight: 700;
  //   color: #707070;
  //   margin:40px 10%;
  //   text-align: left;
  // }
  .button-container {
    text-align: center;
  }
}

.avatar-uploader  .el-upload{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>
